import { Timestamp, doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from './firebase';

export interface OrdersPolicyConfig {
  allowClientOrderId: boolean;
  enforceServerOrderId: boolean;
  writeClientServerMapping: boolean;
  enableStatusSanitization: boolean;
  updatedAt?: Date;
}

const REF = doc(db, 'config', 'orders');

const DEFAULT_CONFIG: OrdersPolicyConfig = {
  allowClientOrderId: true,
  enforceServerOrderId: false,
  writeClientServerMapping: true,
  enableStatusSanitization: true,
};

const toJsDate = (value: unknown): Date | undefined => {
  if (value instanceof Timestamp) {
    return value.toDate();
  }
  return undefined;
};

export async function getOrdersPolicyConfig(): Promise<OrdersPolicyConfig> {
  const snap = await getDoc(REF);
  if (!snap.exists()) {
    return { ...DEFAULT_CONFIG };
  }

  const data = snap.data() as Partial<OrdersPolicyConfig>;
  return {
    allowClientOrderId:
      typeof data.allowClientOrderId === 'boolean'
        ? data.allowClientOrderId
        : DEFAULT_CONFIG.allowClientOrderId,
    enforceServerOrderId:
      typeof data.enforceServerOrderId === 'boolean'
        ? data.enforceServerOrderId
        : DEFAULT_CONFIG.enforceServerOrderId,
    writeClientServerMapping:
      typeof data.writeClientServerMapping === 'boolean'
        ? data.writeClientServerMapping
        : DEFAULT_CONFIG.writeClientServerMapping,
    enableStatusSanitization:
      typeof data.enableStatusSanitization === 'boolean'
        ? data.enableStatusSanitization
        : DEFAULT_CONFIG.enableStatusSanitization,
    updatedAt: toJsDate(data.updatedAt),
  };
}

export async function updateOrdersPolicyConfig(
  partial: Partial<OrdersPolicyConfig>
): Promise<OrdersPolicyConfig> {
  await setDoc(
    REF,
    {
      ...partial,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );

  return await getOrdersPolicyConfig();
}
